import * as permission from './permissions.js';

export const VIEW_GROUP = 'viewGroup';
export const CREATE_GROUP = 'createGroup';
export const VIEW_USER = 'viewUser';
export const UPDATE_USER = 'updateUser';
export const CREATE_USER = 'createUser';
export const VIEW_MAIL = 'viewMail';
export const UPDATE_MAIL = 'updateMail';
export const UPDATE_PASS = 'updatePass';
export const VIEW_PREVIOUS_PROGRAM = 'viewPreviousProgram';
export const VIEW_PREVIOUS_PROGRAM_DETAIL = 'viewPreviousProgramDetail';
export const VIEW_PAYMENT = 'viewPayment';
export const VIEW_PAYMENT_DETAIL = 'viewPaymentDetail';
export const VIEW_ADVANCE_PAYMENT = 'viewAdvancePayment';
export const VIEW_ANTICIPATION_PAYMENT = 'viewAnticipationPayment';
export const VIEW_SALE_ORDER = 'viewSaleOrder';
export const VIEW_CONTENT = 'viewContent';
export const CREATE_CONTENT = 'createContent';
export const BILLING_STATEMENT = 'billingStatement';
export const VIEW_DISCOUNT_AND_INVOINCE = 'viewDiscountAndInvoice';
export const VIEW_MANAGEMENT_ADVANCES_INVOICES = 'viewManagemenetAdvanceAndInvoice';
export const VIEW_ZONE_ADMIN = 'viewZoneAdmin';
export const VIEW_ADVANCES_INVOICES_AND_COMPLEMENTS = 'viewAdvancesInvoicesAndComplements'
export const VIEW_TERMS_AND_CONDITIONS="viewTermsAndConditions"
export const UPLOAD_TERMS_AND_CONDITIONS = "uploadTermsAndConditions"
export const VIEW_SLIDER = 'viewSlider'
export const VIEW_REFERENCE_PAYMENT = 'viewReferencePayment';
export const UPDATE_REFERENCE_PAYMENT = 'updateReferencePayment';
export const VIEW_URL_BANK = 'viewUrlBank'
export const viewsList = [
    {
      id: 1,
      name: "Ver grupos",
      key: VIEW_GROUP,
      showContent: true,
      permissions:[
        permission.VIEW_ALL_GROUPS
      ]
    },
    {
      id: 2,
      name: "Crear/Actualizar grupos",
      key: CREATE_GROUP,
      showContent: true,
      permissions:[
        permission.VIEW_ALL_GROUPS,
        permission.CREATE_GROUP,
        permission.UPDATE_GROUP,
        permission.VIEW_GROUP_BY_ID,
        permission.VIEW_PERMISSION_LIST,
        permission.VIEW_LIST_OF_USERS

      ]
    },
    {
      id: 3,
      name: "Ver representantes",
      key: VIEW_USER,
      showContent: true,
      permissions:[
        permission.VIEW_MANAGER_LIST
      ]
    },
    {
      id: 4,
      name: "Actualizar estado representantes",
      key: UPDATE_USER,
      showContent: true,
      permissions:[
        permission.UPDATE_STATUS_OF_USER,
      ]
    },
    {
      id: 5,
      name: 'Agregar/Actualizar representante',
      key: CREATE_USER,
      showContent: true,
      permissions:[
        permission.UPDATE_STATUS_OF_USER,
        permission.CREATE_ADMINISTRATOR,
        permission.CREATE_MANAGER,
        permission.UPDATE_MANAGER
      ]
    },
    {
      id:8,
      name:'Actualizar contraseña',
      key: UPDATE_PASS,
      showContent: true,
      permissions:[
        permission.UPDATE_PASSWORD
      ]
    },
    {
      id:9,
      name:'Ver programa previo',
      key: VIEW_PREVIOUS_PROGRAM,
      showContent: true,
      permissions:[
        permission.VIEW_PREVIOUS_PROGRAM,
        permission.GET_CALENDAR,
        permission.GET_YEAR,
        permission.GET_CEMENT,
        permission.GET_MONTH,
        permission.GET_PLANT_OF_COMPANY,
        permission.GET_RETIREMENT,
        permission.VIEW_USER_ASSOCIATED_LIST
      ]
    },
    {
      id:10,
      name:'Ver detalle del programa previo',
      key: VIEW_PREVIOUS_PROGRAM_DETAIL,
      showContent: true,
      permissions:[
        permission.GET_CEMENT_DETAIL,
        permission.GET_DATE_DETAILS,
        permission.GET_PLANT_DETAILS_OF_COMPANY,
        permission.GET_DOCUMENT_EXCEL,
        permission.GET_RETIREMENT_DETAILS,
        permission.VIEW_USER_ASSOCIATED_LIST
      ]
    },
    {
      id:11,
      name:'Ver pago de facturas',
      key: VIEW_PAYMENT,
      showContent: true,
      permissions:[
        permission.PAYMENT,
        permission.SAVE_INVOICE,
        permission.GET_INVOICE,
        permission.GET_PDF_OF_INVOICE,
        permission.VIEW_USER_ASSOCIATED_LIST,
        permission.TRUE_PAYMENT,
        permission.FALSE_PAYMENT,
        permission.GET_TYPE_INVOICE,
        permission.GET_EXCEL_INVOICE,
        permission.SAVE_PAYMENT_INFORMATION,
        permission.DELETE_CANCELED_PAYMENT,
        

      ]
    },
    {
      id:12,
      name:'Ver pagos procesados',
      key: VIEW_PAYMENT_DETAIL,
      showContent: true,
      permissions:[
        permission.PAYMENT_DETAIL,
        permission.GET_YEAR,
        permission.VIEW_USER_ASSOCIATED_LIST,
        permission.GET_EXCEL_OF_PAYMENT_PROCESSED
      ]
    },
    {
      id:13,
      name:'Ver anticipos',
      key: VIEW_ADVANCE_PAYMENT,
      showContent: true,
      permissions:[
        permission.ADVANCE_PAYMENT,
        permission.SAVE_ANTICIPATION,
        permission.GET_PAYMENT_CONCEPT,
        permission.VIEW_USER_ASSOCIATED_LIST,
        permission.SAVE_PAYMENT_INFORMATION,
        permission.DELETE_CANCELED_PAYMENT_ANTICIPATION,
        permission.HAS_CASH_PAYMENT_PERMITS
      ]
    },
    {
      id:14,
      name:'Ver pagos de anticipo',
      key: VIEW_ANTICIPATION_PAYMENT,
      showContent: true,
      permissions:[
        permission.VIEW_ANTICIPATION_PAYMENT,
        permission.GET_YEAR,
        permission.VIEW_USER_ASSOCIATED_LIST
      ]
    },
    {
      id:15,
      name:'Ver órdenes de venta',
      key: VIEW_SALE_ORDER,
      showContent: true,
      permissions:[
        permission.SALE_ORDERS,
        permission.GET_DATE_ORDER,
        permission.GET_PLANT_ORDER_OF_COMPANY,
        permission.VIEW_USER_ASSOCIATED_LIST,
        permission.GET_EXCEL_SALE_ORDER
      ]
    },
    {
      id:16,
      name:'Ver contenidos',
      key: VIEW_CONTENT,
      showContent: true,
      permissions:[
        permission.VIEW_CONTENT_MARKETING,
        permission.GET_DOCUMENT,
        permission.GET_SECTION
      ]
    },
    {
      id:17,
      name:'Actualizar contenidos',
      key: CREATE_CONTENT,
      showContent: false,
      permissions:[
        permission.VIEW_CONTENT_MARKETING,
        permission.CREATE_CONTENT_MARKETING,
        permission.UPDATE_CONTENT_MARKETING,
        permission.GET_DOCUMENT,
        permission.GET_DOCUMENT_BY_ID,
        permission.GET_SECTION,
        permission.CREATE_DOCUMENT,
        permission.UPDATE_DOCUMENT,
        permission.DELETE_DOCUMENT_BY_ID
      ]
    },
    {
        id: 18,
        name:'Ver estados de cuenta',
        key: BILLING_STATEMENT,
        showContent: true,
        permissions:[
          permission.DOWNLOAD_ACCOUNT_STATUS,
          permission.VIEW_USER_ASSOCIATED_LIST
        ]
    },
    {
      id: 19,
      name: 'Ver bonificaciones y descuentos',
      key: VIEW_DISCOUNT_AND_INVOINCE,
      showContent: true,
      permissions:[
        permission.GET_DISCOUNT_INVOICE_HEADER,
        permission.GET_DISCOUNT_INVOICE_DETAIL,
        permission.VIEW_USER_ASSOCIATED_LIST,
        permission.GET_DISCOUNT_INVOICE_DETAIL_ORIGIN,
        permission.GET_EXCEL_OF_DISCOUNT_INVOICE_HEADER,
        permission.GET_EXCEL_OF_DISCOUNT_INVOICE_ORIGIN,
        permission.GET_EXCEL_OF_DISCOUNT_INVOICE_APPLICATION
      ]
    },
    {
      id: 20,
      name: 'Ver consulta de anticipos',
      key: VIEW_MANAGEMENT_ADVANCES_INVOICES,
      showContent: true,
      permissions:[
        permission.VIEW_MANAGEMENT_ADVANCES_INVOICES,
        permission.VIEW_USER_ASSOCIATED_LIST,
        permission.VIEW_MANAGEMENT_ADVANCES_INVOICES_DETAIL,
        permission.GET_EXCEL_OF_ADVANCES_INVOICES_HEADER,
        permission.GET_EXCEL_OF_ADVANCES_INVOICES_DETAIL ,
         
      ]
    },
    {
      id: 21,
      name: 'Editar administrador de zona',
      key: VIEW_ZONE_ADMIN,
      showContent: false,
      permissions:[
        permission.VIEW_LIST_AN8,
        permission.CREATE_ZONE_ADMINISTRATOR,
        permission.ASSIGN_AN8_TO_ZONE_MANAGER,
        permission.UPDATE_ASSIGNMENT_AN8_TO_ZONE_MANAGER
      ]
    },
    {
      id: 22,
      name: 'Ver consulta de facturas',
      key: VIEW_ADVANCES_INVOICES_AND_COMPLEMENTS,
      showContent: true,
      permissions:[
        permission.VIEW_LIST_AN8,
        permission.GET_INVOICE_CONSULTATION_HEADER,
        permission.GET_DETAIL_SALES,
        permission.GET_DETAIL_DISCOUNT,
        permission.GET_DETAIL_ANTICIPATION,
        permission.DOWNLOAD_HEADER_PDF,
        permission.GET_EXCEL_INVOICE,
        permission.GET_PDF_OF_INVOICE,
        permission.GET_EXCEL_OF_ANTICIPATION_PAYMENT
      ]
    },
    {
      id:23,
      name:'Ver terminos y condiciones',
      key: VIEW_TERMS_AND_CONDITIONS,
      showContent:false,
      permissions:[
       permission.VIEW_DOCUMENTS_OF_TERMS_AND_CONDITIONS
      ]
    },
    {
      id:24,
      name:'Cargar archivo terminos y condiciones',
      key: UPLOAD_TERMS_AND_CONDITIONS,
      showContent: false,
      permissions:[
        permission.UPLOAD_DOCUMENT_TERMS_AND_CONDITIONS,
      ]
    },
    {
      id:25,
      name:'Editar slider de imágenes ',
      key: VIEW_SLIDER,
      showContent: false,
      permissions:[
        permission.UPLOAD_MULTIMEDIA_FOR_SLIDER,
        permission.DELETE_IMAGES_OF_THE_SLIDER,
        permission.MODIFY_NAME_OF_IMAGES_OF_THE_SLIDER,
        permission.VIEW_LIST_OF_IMAGES_OF_THE_SLIDER
      ]
    },
    {
      id:26,
      name:'referencia de pago',
      key: VIEW_REFERENCE_PAYMENT,
      showContent:false,
      permissions:[
        permission.GET_DETAILS_OF_PAYMENT,
        permission.UPDATE_REFERENCE_Of_PAYMENT
      ],
      
    },
   
    {
      id:26,
      name:'permisos de bajio',
      key: VIEW_URL_BANK,
      showContent:false,
      permissions:[
        permission.PAYMENT_REQUEST_TO_BANK,
        permission.SAVE_INVOICE_DATA,
        permission.SAVE_ADVENCE_PAYMENT,
        permission.VALIDATE_IF_YOU_CAN_PAY_WITH_BAJIO
      ],
      
    },
   
        // {
    //   id:,
    //   name:'',
    //   key: '',
    //   permissions:[
    //   ]
    // }
  ];